import Component from '../abstracts/Component';

export default class DropdownSizeSelectorComponent extends Component {

  get COMPONENTNAME() {
    return 'DropdownSizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      trigger: '[data-sizes-trigger]',
      select: '[data-sizes-select]',
      dropdown: '[data-sizes-dropdown]',
      size: '[data-size]',
      sizeError: '[data-sizes-error]',
      sizeSelected: '[data-size-selected]',
      sizesInfo: '[data-sizes-info]',
      selectSizeDefault: '[data-size-select-default]',
      sizesValue: '[data-size-value]',
      sizeOptions: '[data-options]',
      sizeIcon: '[data-icon]',
      valueSelected: '[data-value-selected]',
      valueOptions: '[data-options-selected]',
      valueIcon: '[data-icon-selected]',
      // class selector because is used to obtain selected size
      selectedClass: '.selected'
    };
  }

  get CLASSES() {
    return {
      arrow: 'js-arrow',
      hidden: '--hidden',
      noFixedHeight: '--no-fixed-height',
      open: 'open',
      pdpSizes: 'c-pdp-sizes',
      selected: 'selected',
      show: 'show'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.clickOutside = this.clickOutside.bind(this);
    this.trigger = this.$component.querySelector(this.SELECTORS.trigger);
    this.sizeSelect = this.$component.querySelector(this.SELECTORS.select);
    this.sizeDropdown = this.$component.querySelector(this.SELECTORS.dropdown);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.size);
    this.sizeError = this.$component.querySelector(this.SELECTORS.sizeError);
    this.selected = this.$component.querySelector(this.SELECTORS.sizeSelected);
    this.box = this.$component;
    this.sizesInfo = this.$component.querySelector(this.SELECTORS.sizesInfo);
    this.productCode = this.$component.dataset.productCode;
    this.selectSizeDefault = this.$component.querySelector(this.SELECTORS.selectSizeDefault);
    this.valueSelected = this.$component.querySelector(this.SELECTORS.valueSelected);
    this.valueOptions = this.$component.querySelector(this.SELECTORS.valueOptions);
    this.valueIcon = this.$component.querySelector(this.SELECTORS.valueIcon);
  }

  cleanSelectSize() {
    this.sizes.forEach(size => {
      size.classList.remove(this.CLASSES.selected);
    });
    // this.valueSelected = this.$component.querySelector(this.SELECTORS.valueSelected);
    this.selectSizeDefault.classList.remove(this.CLASSES.hidden);
    this.selected.removeAttribute('data-unavailable');
    this.valueSelected.classList.add(this.CLASSES.hidden);
    this.valueOptions.classList.add(this.CLASSES.hidden);
    this.valueIcon.classList.add(this.CLASSES.hidden);
    // reset value
    if (typeof this.sizeSelect !== 'undefined' && this.sizeSelect != null) {
      this.sizeSelect.value = '';
    }
  }

  clickOutside(e) {
    if (e.target !== this.trigger && e.target !== this.sizesInfo && !e.target.classList.contains(this.CLASSES.arrow)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.trigger.classList.remove(this.CLASSES.open);
    document.removeEventListener('click', this.clickOutside);
  }

  selectSize(size) {
    // obtain previous selected size
    let previousSelectedSize = this.sizeDropdown.querySelector(this.SELECTORS.selectedClass);
    // deselect size
    if (previousSelectedSize) {
      previousSelectedSize.classList.remove(this.CLASSES.selected);
    }
    // select new selected size
    size.classList.add(this.CLASSES.selected);
    // hide default label
    this.selectSizeDefault.classList.add(this.CLASSES.hidden);
    this.selected.dataset.unavailable = size.dataset.unavailable;
    // update size value selected
    this.valueSelected.innerHTML = size.querySelector(this.SELECTORS.sizesValue).innerHTML;
    this.valueSelected.classList.remove(this.CLASSES.hidden);
    // update size options selected
    this.valueOptions.innerHTML = size.querySelector(this.SELECTORS.sizeOptions).innerHTML;
    this.valueOptions.classList.remove(this.CLASSES.hidden);
    // update size icon selected
    this.valueIcon.innerHTML = size.querySelector(this.SELECTORS.sizeIcon).innerHTML;
    this.valueIcon.classList.remove(this.CLASSES.hidden);
    // close dropdown
    this.closeDropdown();
  }

  toggleDropdown() {
    this.trigger.classList.toggle(this.CLASSES.open);
    this.trigger.scrollIntoView({behavior: 'smooth', block: 'center'});
    document.addEventListener('click', this.clickOutside);
    this.sizeDropdown.addEventListener('click', e => e.stopPropagation());
  }

  bindEvents() {
    this.trigger.addEventListener('click', () => {
      this.toggleDropdown();
    });
    if (this.sizesInfo) {
      this.sizesInfo.addEventListener('click', () => {
        this.toggleDropdown();
      });
    }
    if (this.sizes.length) {
      this.sizes.forEach(size => {
        size.addEventListener('click', () => {
          // put size
          this.selectSize(size);
          // if not available launch notify me event
          if (size.dataset.unavailable == 'true') {
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {
              size: size,
              box: this.box,
              productCode: this.productCode
            });
          } else {
            // if available i want to hide the notifyme form
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, {
              size: size,
              box: this.box,
              productCode: this.productCode
            });
          }

          this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged, {
            productCode: size.getAttribute('data-product-code'),
            baseProductCode: this.productCode,
            sizeSelected: size.dataset.value,
            size: size
          });

          // reset error
          if (this.sizeError) {
            this.sizeError.innerHTML = '';
            this.sizeError.classList.remove(this.CLASSES.show);
          }
        });
        if (size.dataset.uniqueSize == 'true') {
          this.selectSize(size);
        }
      });
    }

    // on notifymesuccess reset select
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymesuccess, () => {
      // reset value
      this.cleanSelectSize();
    });

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      let sizeErrorBoxes = document.querySelectorAll(`[data-sizes-error=prod-${e.payload.dataset.code}]`);
      // put error
      sizeErrorBoxes.forEach(sizeErrorBox => {
        if (sizeErrorBox && !sizeErrorBox.classList.contains(this.CLASSES.show)) {
          // if we are in complete the look, we also need to change parent height in order to see error message
          const parentElem = sizeErrorBox.parentElement.parentElement;
          if (parentElem && parentElem.classList.contains(this.CLASSES.pdpSizes)) {
            parentElem.classList.add(this.CLASSES.noFixedHeight);
          }
          sizeErrorBox.classList.add(this.CLASSES.show);
          sizeErrorBox.innerHTML = e.payload.attributes['data-notification'].nodeValue;
        }
      });
    });


    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({payload}) => {
      if (payload.baseProductCode === this.$component.dataset.productCode) {
        // reset value
        this.cleanSelectSize();
      }
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
